import axios from 'axios'
import { unwrapApiEnvelope } from '@/shared/lib/api-envelope'
import { buildApiUrl } from '@/shared/lib/api-origin'
import { getAuthToken } from '@/shared/lib/auth-token'

export function createPublicClaimApi(tenantSlug: string) {
  const instance = axios.create({
    baseURL: buildApiUrl(`/api/public/claims/${tenantSlug}`),
    headers: { 'Content-Type': 'application/json' },
  })

  instance.interceptors.request.use((config) => {
    // Public endpoints accept anonymous submissions; when a consumer is signed
    // in, forward their session token so the claim is attributed to them.
    const token = getAuthToken()
    if (token) {
      config.headers['X-Session-Token'] = token
    }
    return config
  })

  instance.interceptors.response.use((response) => unwrapApiEnvelope(response))

  return instance
}
